/**
 * Логика потолков: вид по енаму и по id из ссылки каталога и итоговый вид потолка
 * комнаты (настройки слоя поверх каталога).
 */
import type { RoomCeiling } from "@/shared/plan";
import { ceilingSection } from "./catalog";
import type { CeilingCatalogItem, CeilingLook, CeilingMaterial } from "./types";

/** Вид потолка из каталога; неизвестный — первый, чтобы потолок не пропал. */
export const getCeilingMaterial = (material: CeilingMaterial): CeilingCatalogItem =>
	ceilingSection.items.find((item) => item.material === material) ?? ceilingSection.items[0];

/** Вид по строковому id из ссылки каталога (`CatalogRef.item`). */
export const ceilingItemById = (id: string): CeilingCatalogItem | null =>
	ceilingSection.items.find((item) => item.id === id) ?? null;

/** Итоговый вид потолка: что пользователь поменял — из слоя, остальное — из каталога. */
export const ceilingLook = (ceiling: RoomCeiling): CeilingLook => {
	const item = getCeilingMaterial(ceiling.material);
	return {
		material: ceiling.material,
		drop: Math.max(item.minDrop, ceiling.drop ?? item.drop),
		color: ceiling.color ?? item.color,
		glossy: item.glossy,
	};
};
